import { useTheme } from "@verbleif/shared/src/composables/Theme/Theme";

useTheme(); // Does nothing, it just gets imported so the code "runs"
